import React from 'react';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Lots from './pages/Lots';
import Contact from './pages/Contact';
import Map from './pages/Map';
import './styles/App.css';
import Testimonials from './pages/Testimonials';
import Tour from './pages/Tour';
import Finance from './pages/Finance';
import Cangrejos from './pages/Cangrejos';
import Pinuelos from './pages/Pinuelos';
import Vista from './pages/Vista';
import Manglares from './pages/Manglares';
import Legal from './pages/Legal';


function App() {

  const [language, setLanguage] = useState(
  localStorage.getItem('simpleLang') || 'es' );

  return (


    <Router>
      <Navbar 
        language={language}
        setLanguage={(lang) => {
          localStorage.setItem('simpleLang', lang);
          setLanguage(lang);
        }}
      />

      <Routes>
        <Route path="/" element={<Home language={language}/>} />
        <Route path="/lots" element={<Lots language={language}/>} />
        <Route path="/contact" element={<Contact language={language}/>} />
        <Route path="/map" element={<Map language={language}/>} />
        <Route path="/testimonials" element={<Testimonials language={language}/>} />
        <Route path="/tour" element={<Tour language={language}/>} />
        <Route path="/finance" element={<Finance language={language}/>} />
        <Route path="/cangrejos" element={<Cangrejos language={language}/>} />
        <Route path="/pinuelos" element={<Pinuelos language={language}/>} />
        <Route path="/vista" element={<Vista language={language}/>} />
        <Route path="/manglares" element={<Manglares language={language}/>} />
        <Route path="/legal" element={<Legal language={language}/>} />

      </Routes>
    </Router>
  );
}

export default App;